// Footer newsletter collapsible fix
document.addEventListener('DOMContentLoaded', function() {
  var btn = document.querySelector('.footer__item--newsletter .collapsible-trigger-btn');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var content = this.closest('.footer__item-padding').querySelector('.collapsible-content');
    if (!content) return;
    var isOpen = content.classList.contains('is-active');
    content.classList.toggle('is-active', !isOpen);
    this.setAttribute('aria-expanded', String(!isOpen));
  });
});

// ===== 居中两级颜色筛选器 =====
(function() {
  var popup = document.createElement('div');
  popup.className = 'color-subgroup-flyout';
  popup.setAttribute('role', 'dialog');
  popup.setAttribute('aria-label', 'Color shades');
  popup.style.cssText = 'display:none;position:fixed;background:#fff;border:1px solid #e0e0e0;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.16);padding:14px;z-index:2147483647;width:420px;max-height:60vh;overflow-y:auto;overflow-x:hidden;';
  document.body.appendChild(popup);

  var activeItem = null;
  var activeButton = null;
  var closeTimer = null;

  function cancelClose() {
    window.clearTimeout(closeTimer);
  }

  function closePopup() {
    cancelClose();
    popup.style.display = 'none';
    if (activeItem) activeItem.classList.remove('is-open');
    if (activeButton) activeButton.setAttribute('aria-expanded', 'false');
    activeItem = null;
    activeButton = null;
    window.removeEventListener('scroll', positionPopup, true);
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = window.setTimeout(closePopup, 140);
  }

  function positionPopup() {
    if (!activeButton) return;
    var rect = activeButton.getBoundingClientRect();
    var popupWidth = Math.min(420, window.innerWidth - 16);
    var left = rect.left + (rect.width / 2) - (popupWidth / 2);
    left = Math.max(8, Math.min(left, window.innerWidth - popupWidth - 8));
    popup.style.width = popupWidth + 'px';
    popup.style.top = (rect.bottom + 10) + 'px';
    popup.style.left = left + 'px';
  }

  function openPopup(item) {
    var button = item.querySelector('.color-group-btn');
    var source = item.querySelector('.color-subgroup-popup');
    if (!button || !source) return;
    cancelClose();
    if (activeItem === item) return;
    closePopup();
    popup.innerHTML = source.innerHTML;
    activeItem = item;
    activeButton = button;
    activeItem.classList.add('is-open');
    activeButton.setAttribute('aria-expanded', 'true');
    popup.style.display = 'block';
    positionPopup();
    window.addEventListener('scroll', positionPopup, true);
  }

  document.addEventListener('mouseover', function(event) {
    var button = event.target.closest('.color-group-btn');
    if (!button) return;
    var item = button.closest('.color-group-item');
    if (item && !item.contains(event.relatedTarget)) openPopup(item);
  });

  document.addEventListener('mouseout', function(event) {
    var item = event.target.closest('.color-group-item');
    if (!item || item !== activeItem) return;
    if (!item.contains(event.relatedTarget) && !popup.contains(event.relatedTarget)) scheduleClose();
  });

  popup.addEventListener('mouseenter', cancelClose);
  popup.addEventListener('mouseleave', scheduleClose);

  document.addEventListener('focusin', function(event) {
    var button = event.target.closest('.color-group-btn');
    if (button) openPopup(button.closest('.color-group-item'));
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.color-group-btn');
    if (button) {
      event.preventDefault();
      openPopup(button.closest('.color-group-item'));
      return;
    }
    if (!popup.contains(event.target) && !event.target.closest('.color-group-item')) closePopup();
  });

  popup.addEventListener('click', function(event) {
    var item = event.target.closest('.color-sub-item');
    if (!item) return;
    event.preventDefault();
    var checkbox = item.querySelector('.tag__input');
    if (!checkbox) return;
    var url = new URL(window.location.href);
    url.searchParams.set(checkbox.name, checkbox.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
